import { useState, useEffect } from 'react';
import './RotatingText.css';

function RotatingText({ statements, interval = 3000, className = '' }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (!statements || statements.length === 0) return;

    const timer = setInterval(() => {
      setIsAnimating(true);
      
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % statements.length);
        setIsAnimating(false);
      }, 500); // Half of animation duration
    }, interval);

    return () => clearInterval(timer);
  }, [statements, interval]);

  if (!statements || statements.length === 0) {
    return null;
  }

  return (
    <div className={`rotating-text-container ${className}`}>
      <div className={`rotating-text ${isAnimating ? 'slide-out' : 'slide-in'}`}>
        {statements[currentIndex]}
      </div>
    </div>
  );
}

export default RotatingText;
